// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    padding: 20px;
}

.table-container {
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
}

th, td {
    padding: 8px;
    border-bottom: 1px solid #ddd;
}

th {
    background-color: #f2f2f2;
}

.container {
    position: relative;
}

.add-state-button {
    position: absolute;
    top: 10px;
    right: 10px;
}

.add-state-button a {
    text-decoration: none;
    color: #fff;
    background-color: #007bff;
    padding: 8px 12px;
    border-radius: 4px;
}

.add-language-button a:hover {
    background-color: #0056b3;
}

.panel-heading {
    font-weight: bold;
    display: block; /* Make sure the header spans the whole row */
    width: 100%;    /* Ensure it takes up the full width of the parent */
    text-align: center; /* Optional: Center the text */
    background-color: #f0f0f0; /* Optional: Add a background color */
    padding: 10px; /* Optional: Add some padding */
}
body {
    font-family: Arial, sans-serif;
}

.container {
    width: 80%;
    margin: 0 auto;
}

.panel-heading {
    font-weight: bold;
    display: block;
    width: 100%;
    text-align: center;
    background-color: #f0f0f0;
    padding: 10px;
    margin-bottom: 10px;
}

.tabs {
    display: flex;
    justify-content: space-around;
    background-color: #e0e0e0;
    padding: 5px;
}

.tab-button {
    background-color: #e0e0e0;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
}

.tab-button.active {
    background-color: #d0d0d0;
    border-bottom: 2px solid #000;
}

.tab-content {
    display: none;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-top: none;
}

.tab-content.active {
    display: block;
}

form {
    display: flex;
    flex-direction: column;
}

label {
    margin: 10px 0 5px;
}

input, select {
    padding: 5px;
    margin-bottom: 10px;
    /* border: 1px solid #ccc; */
}

button {
    padding: 10px;
    margin-right: 5px;
    border: none;
    cursor: pointer;
}

button[type="submit"] {
    background-color: #4CAF50;
    color: white;
}

button[type="reset"] {
    background-color: #f44336;
    color: white;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ads/Ads.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc,EAAE,6CAA6C;IAC7D,WAAW,KAAK,oDAAoD;IACpE,kBAAkB,EAAE,8BAA8B;IAClD,yBAAyB,EAAE,qCAAqC;IAChE,aAAa,EAAE,+BAA+B;AAClD;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":[".container {\n    padding: 20px;\n}\n\n.table-container {\n    overflow-x: auto;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n}\n\nth, td {\n    padding: 8px;\n    border-bottom: 1px solid #ddd;\n}\n\nth {\n    background-color: #f2f2f2;\n}\n\n.container {\n    position: relative;\n}\n\n.add-state-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}\n\n.add-state-button a {\n    text-decoration: none;\n    color: #fff;\n    background-color: #007bff;\n    padding: 8px 12px;\n    border-radius: 4px;\n}\n\n.add-language-button a:hover {\n    background-color: #0056b3;\n}\n\n.panel-heading {\n    font-weight: bold;\n    display: block; /* Make sure the header spans the whole row */\n    width: 100%;    /* Ensure it takes up the full width of the parent */\n    text-align: center; /* Optional: Center the text */\n    background-color: #f0f0f0; /* Optional: Add a background color */\n    padding: 10px; /* Optional: Add some padding */\n}\nbody {\n    font-family: Arial, sans-serif;\n}\n\n.container {\n    width: 80%;\n    margin: 0 auto;\n}\n\n.panel-heading {\n    font-weight: bold;\n    display: block;\n    width: 100%;\n    text-align: center;\n    background-color: #f0f0f0;\n    padding: 10px;\n    margin-bottom: 10px;\n}\n\n.tabs {\n    display: flex;\n    justify-content: space-around;\n    background-color: #e0e0e0;\n    padding: 5px;\n}\n\n.tab-button {\n    background-color: #e0e0e0;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n}\n\n.tab-button.active {\n    background-color: #d0d0d0;\n    border-bottom: 2px solid #000;\n}\n\n.tab-content {\n    display: none;\n    padding: 10px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-top: none;\n}\n\n.tab-content.active {\n    display: block;\n}\n\nform {\n    display: flex;\n    flex-direction: column;\n}\n\nlabel {\n    margin: 10px 0 5px;\n}\n\ninput, select {\n    padding: 5px;\n    margin-bottom: 10px;\n    /* border: 1px solid #ccc; */\n}\n\nbutton {\n    padding: 10px;\n    margin-right: 5px;\n    border: none;\n    cursor: pointer;\n}\n\nbutton[type=\"submit\"] {\n    background-color: #4CAF50;\n    color: white;\n}\n\nbutton[type=\"reset\"] {\n    background-color: #f44336;\n    color: white;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
